module.exports = __webpack_public_path__ + "static/media/mononoke-loc.1e0d5b94.JPG";